import * as MeFormI from "./MeForm";
import * as MeCastI from "./MeCast";

const SequencePattern: {
  [name: string]: { [flavor: string]: { [func: string]: any } };
} = {
  MeForm: {
    default: {
      START: MeFormI.Start,
      Action: MeFormI.Action,
    },
  },
  MeCast: {
    default: {
      START: MeCastI.Start,
      Action: MeCastI.Action,
    },
  },
};

export default SequencePattern;